module.exports = __webpack_public_path__ + "img/bim (11).0688777d.png";